import { NotificationCertificationWidget } from "@hatch-digital-nl/abs-storybook/legacy";
import Skeleton from "react-loading-skeleton";
import { JSX } from "react";
import { EmployeeDetailStatusButtons } from "./EmployeeDetailStatusButtons";
import { useEmployeeDetailSidebar } from "../hooks/useEmployeeDetailSidebar";

export const EmployeeDetailSidebar = (): JSX.Element | null => {
    const { isLoading, shouldRender, notifications, onAddCertificate } =
        useEmployeeDetailSidebar();

    if (isLoading) {
        return (
            <aside className={"p-employee-detail__content__sidebar"}>
                <Skeleton
                    height={"60rem"}
                    width={"49rem"}
                    borderRadius={"1.5rem"}
                />
            </aside>
        );
    }

    if (!shouldRender) {
        return null;
    }

    return (
        <aside className={"p-employee-detail__content__sidebar"}>
            {notifications && (
                <NotificationCertificationWidget
                    notifications={notifications}
                    certificate={{
                        link: {
                            text: "Certificaat toevoegen",
                            onClick: onAddCertificate,
                        },
                    }}
                />
            )}
            <EmployeeDetailStatusButtons />
        </aside>
    );
};
